import { connect } from 'react-redux'
import { SpreadSheet } from 'Components'
import { removeGraphNodes } from 'Actions/graph'

TableViewContainer = ({ currentProject, left, height, removeGraphNodes, tableConfig, width }) ->

  <SpreadSheet
    width={width - (left + 80)}
    height={height - 81}
    tableProps={tableConfig}
    onRemoveNodes={removeGraphNodes}
    cellHeight={30}
  />

export default connect(
  ({
    explore: { tableConfig, width }
    projects: { currentProject }
  }) -> { currentProject, tableConfig, width }
, { removeGraphNodes }
)(TableViewContainer)
